import createMediaQueries from './create-media-queries';
import { getaAssetPath } from '../../util';
import themeContract from './theme-contract.json';

const color1 = '#65AC4B';
const color2 = '#EA157F';
const color3 = '#545654';
const color4 = '#FED39A';
const color5 = '#7A959A';
const color6 = '#C6D8E0';
const color7 = '#000000';
const color8 = '#FFFFFF';

const stockTheme = (name) => ({
  color: {
    primary: themeContract.themes[name].color,
    surveyText: color8,
  },
  asset: {
    background: getaAssetPath(themeContract.themes[name].bg),
  },
});

export default {
  asset: {},
  color: {
    // NEW
    color1,
    color2,
    color3,
    color4,
    color5,
    color6,
    color7,
    color8,
    black: color7,
    success: '#65AC4B',
    warning: '#EA157F',

    // old
    border: color6,
    brown: color3,
    brown2: color3,
    brown3: color4,
    brown4: color6,
    gray: color3,
    gray2: color6,
    gray3: color8,
    gray4: '#ededed',
    outline: '#31C1F4',
    primary: themeContract.base.color,
    surveyText: color8,
    text: color7,
    white: color8,
  },
  depth: {
    overlay: 240,
    popover: 20,
  },
  font: {
    size: {
      main: '18px',
    },
  },
  media: createMediaQueries(),
};

export const inactive = stockTheme('inactive');

export const aristotle = stockTheme('aristotle');

export const darwin = stockTheme('darwin');

export const kepler = stockTheme('kepler');

export const newton = stockTheme('newton');

export const pascal = stockTheme('pascal');
